import React from 'react';
import ReactDOM from 'react-dom';
import ClaroApp from './ClaroApp';
import reportWebVitals from './reportWebVitals';

// Sass
import './Sass/main.sass'
import './Sass/includes/Components/modules/paquetesMiNegocio.sass'

ReactDOM.render(
  <React.StrictMode>
    <ClaroApp />
  </React.StrictMode>,
  document.getElementById('componentPlanesNegocio')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
